<template>
    <div>
        <div class="formgrid grid p-fluid">
            <div class="field col-2 md:col-2">
                <label>Nº Processo</label>
                <input v-model="numeroProcesso" @input="checkMaxDigits" type="text" maxlength="9" placeholder="Digite até 9 dígitos" />
            </div>
            <div class="field col-2 md:col-2">
                <label>Gestor</label>
                <Dropdown
                    v-model="gestor"
                    :options="usuarios"
                    filter
                    class="outline-none"
                    optionLabel="nome"
                    optionValue="nome"
                    placeholder="Selecione"
                    showClear
                />
            </div>
            <div class="field col-2 md:col-2">
                <label>Unidade</label>
                <Dropdown
                    v-model="unidade"
                    :options="unidades"
                    filter
                    class="outline-none"
                    optionLabel="siglaUnidade"
                    optionValue="siglaUnidade"
                    placeholder="Selecione"
                    showClear
                />
            </div>
            <div class="field col-2 md:col-2">
                <label>Responsável</label>
                <Dropdown
                    v-model="responsavel"
                    :options="usuarios"
                    filter
                    class="outline-none"
                    optionLabel="nome"
                    optionValue="email"
                    placeholder="Selecione"
                    showClear
                />
            </div>
            <div class="field col-2 md:col-2">
                <label>Data Solicitação</label>
                <Calendar v-model="dataSolicitacao" :monthNavigator="true" :yearNavigator="true" :manualInput="false" :showButtonBar="true" />
            </div>
            <div class="field col-2 md:col-2">
                <label>Etapa</label>
                <div>
                    <Dropdown
                        v-model="etapa"
                        :options="etapas"
                        filter
                        class="outline-none"
                        optionLabel="nomeEtapa"
                        placeholder="Selecione uma etapa"
                        showClear
                    />
                </div>
            </div>
            <div class="field col-12 md:col-6">
                <label>Objeto do TR</label>
                <Textarea type="text" v-model="objetoSolicitacao" placeholder="Digite o Objeto do TR" maxlength="1000" />
            </div>
        </div>
        <div class="flex flex-column md:flex-row justify-content-between">
            <div>
                <Button label="Pesquisar" icon="pi pi-search" @click="pesquisar()" />
                <Button label="Limpar" icon="pi pi-refresh" @click="limpar()" class="ml-2 p-button-secondary" />
            </div>
        </div>
    </div>
</template>

<script>
import Service from '../services';
export default {
    components: {},

    emits: ['pesquisar', 'limpar'],

    data() {
        return {
            numeroProcesso: null,
            unidade: null,
            unidades: [],
            responsavel: null,
            usuarios: [],
            gestor: null,
            etapa: null,
            dataSolicitacao: null,
            objetoSolicitacao: null,
            etapas: [],
        };
    },

    methods: {
        checkMaxDigits(event) {
            let input = event.target.value;

            input = input.replace(/\D/g, '');

            if (input.length > 9) {
                input = input.slice(0, 9);
            }
            this.numeroProcesso = input;
        },
        pesquisar() {
            this.$emit('pesquisar', {
                numeroProcesso: this.numeroProcesso,
                unidade: this.unidade,
                gestor: this.gestor,
                responsavel: this.responsavel,
                etapaNome: this.etapa ? this.etapa.nomeEtapa : null,
                dataSolicitacao: this.dataSolicitacao ? this.dataSolicitacao : null,
                objetoSolicitacao: this.objetoSolicitacao,
            });
        },

        obterUsuarios() {
            this.$store.dispatch('addRequest');
            Service.obterUsuarios().then((response) => {
                if (response && response.success) {
                    const uniqueUsuarios = response.data.filter((usuario, index, self) => index === self.findIndex((u) => u.nome === usuario.nome));
                    this.usuarios = uniqueUsuarios;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        obterUnidades() {
            this.$store.dispatch('addRequest');
            Service.obterUnidades().then((response) => {
                if (response.data.length > 0 && response.success) {
                    this.unidades = response.data;
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro ao carregar unidades',
                        detail: 'Erro ao trazer dados do RM.',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },

        obterEtapasPrincipais() {
            this.$store.dispatch('addRequest');
            Service.obterEtapasPrincipais()
                .then((response) => {
                    if (response && response.success) {
                        this.etapas = response.data.map((etapa) => ({
                            nomeEtapa: etapa.nomeEtapa,
                        }));
                    } else {
                        this.etapas = [];
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch(() => {
                    this.etapas = [];
                });
        },
        limpar() {
            this.numeroProcesso = null;
            this.unidade = null;
            this.gestor = null;
            this.responsavel = null;
            this.etapa = null;
            this.dataSolicitacao = null;
            this.objetoSolicitacao = null;
            this.$emit('limpar');
        },
    },

    watch: {
        gestor() {
            if (!this.gestor) {
                this.unidade = '';
                return;
            }

            const gestorComSuaUnidade = this.usuarios.filter((usuario) => usuario.nome == this.gestor);
            const unidadeDoGestor = this.unidades.filter((unidade) => unidade.siglaUnidade == gestorComSuaUnidade[0].siglaUnidade);

            this.unidade = unidadeDoGestor[0]?.siglaUnidade;
        },
    },

    mounted() {
        this.obterUnidades();
        this.obterUsuarios();
        // this.obterResponsaveis();
        this.obterEtapasPrincipais();
    },
};
</script>
<style scoped>
input {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

textarea {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    resize: vertical;
}
</style>
